import { IconProps, TextProps } from '@betty/moonlight';

export type FooterLink = {
  labelKey: Required<TextProps>['locKey'];
  link?: string;
  navigateTo?: string;
  miscPath?: string;
};

export type SocialLink = {
  icon: IconProps['name'];
  link: string;
};

export const FOOTER_LINKS: FooterLink[] = [
  {
    labelKey: 'footerLink_AboutUs',
    miscPath: '/about',
  },
  {
    labelKey: 'footerLink_ContactUs',
    navigateTo: 'ContactUsScreen',
  },
  {
    labelKey: 'footerLink_LevelUp',
    miscPath: '/level-up',
  },
  {
    labelKey: 'footerLink_Status',
    miscPath: '/status',
  },
  {
    labelKey: 'footerLink_PrivacyPolicy',
    miscPath: '/privacy',
  },
  {
    labelKey: 'footerLink_TermsOfUse',
    miscPath: '/terms',
  },
  {
    labelKey: 'footerLink_ResponsibleGaming',
    miscPath: '/responsible-gaming',
  },
  {
    labelKey: 'footerLink_FAQs',
    miscPath: '/faqs',
  },
  {
    labelKey: 'footerLink_Careers',
    link: 'https://job-boards.greenhouse.io/bettygamingca',
  },
];

export const SOCIAL_LINKS: SocialLink[] = [
  {
    icon: 'socialFb',
    link: 'https://www.facebook.com/playbettycasino',
  },
  {
    icon: 'socialIg',
    link: 'https://www.instagram.com/bettyontario',
  },
  {
    icon: 'socialTt',
    link: 'https://www.tiktok.com/@bettyontario',
  },
  {
    icon: 'socialLdin',
    link: 'https://www.linkedin.com/company/bettygaming',
  },
  {
    icon: 'socialYoutube',
    link: 'https://www.youtube.com/@bettycasino_ca',
  },
];
